import Vue from "vue";
import VueRouter from "vue-router";
import { state } from "@/store/";
import Router from 'vue-router';

import AboutUs from '../views/about/AboutUs.vue';
import Intro from '../views/about/Intro.vue';
import Structure from '../views/about/Structure.vue';
import Team from '../views/about/Team.vue';
import Culture from '../views/about/Culture.vue';

// 后台页面组件
import AdminLogin from "../views/admin/login.vue"
import AdminLayout from "../views/admin/layout.vue"
import Product from "../views/admin/product.vue"
import News from "../views/admin/news.vue"
import Partner from "../views/admin/partner.vue"
import Company from "../views/admin/company.vue"
import Contact from "../views/admin/contact.vue";  // 根据你的项目路径修改
import Landscape from "../views/admin/landscape.vue";  // 根据你的项目路径修改
import UserContactHistory from "../views/admin/userContactHistory.vue";  // 根据你的项目路径修改
Vue.use(VueRouter);

const routes = [ 
  // ========== 主页 ==========
  {
    path: "/",
    name: "home",
    component: () => import("../views/Home.vue"),
    meta: { title: "工业智能视觉检测专家" }
  },
  // ========== 产品信息部分 ==========
  {
    path: "/products",
    name: "products",
    component: () => import("../views/product/Products.vue"),
    meta: { title: "产品与解决方案" }
  },
  {
    path: "/products/:id",
    name: "productDetail",
    component: () => import("../views/product/ProductDetail.vue"),
    meta: { title: "产品详情" }
  },
  // ========== 新闻部分 ==========
  {
    path: "/news",
    name: "news",
    component: () => import("../views/news/News.vue"),
    meta: { title: "新闻列表" }
  },
  {
    path: "/news/:id",
    name: "newsDetail",
    component: () => import("../views/news/NewsDetail.vue"),
    meta: { title: "新闻详情" }
  },
  // ========== 联系我们 ==========
  {
    path: "/user",
    name: "user",
    component: () => import("../views/connect/User.vue"),
    meta: { title: "联系我们" }
  },
  // ========== 支付 ==========
  {
    path: "/pay",
    name: "pay",
    component: () => import("../views/pay/Pay.vue"),
    meta: { title: "支付" }
  },
  // ========== 关于我们 ==========
  {
    path: "/about",
    component: AboutUs,
    redirect: "/about/intro",
    children: [
      { path: 'intro', component: Intro, meta: { title: "公司简介" } },
      { path: 'structure', component: Structure, meta: { title: "组织架构" } },
      { path: 'team', component: Team, meta: { title: "团队介绍" } },
      { path: 'culture', component: Culture, meta: { title: "企业文化" } },
    ]
  },

  // ========== 管理员后台部分（保留你的原有配置） ==========
  { 
    path: "/admin/login", 
    name: "adminLogin", 
    component: AdminLogin, 
    meta: { 
      isAdmin: true, 
      requiresAuth: false, 
      isPublic: true,
      title: "管理员登录"
    } 
  },
  {
    path: "/admin",
    component: AdminLayout,
    redirect: "/admin/product",
    meta: { requiresAuth: true, isAdmin: true},
    children: [
      { path: "product", component: Product, meta: { isAdmin: true,requiresAuth: true, title: "产品管理" } },
      { path: "news", component: News, meta: { isAdmin: true,requiresAuth: true, title: "新闻管理" } },
      { path: "partner", component: Partner, meta: { isAdmin: true,requiresAuth: true, title: "合作伙伴管理" } },
      { path: "company", component: Company, meta: { isAdmin: true,requiresAuth: true, title: "公司信息管理" } },
      { path: "contact", component: Contact, meta: { isAdmin: true ,requiresAuth: true, title: "联系方式管理" } },
      { path: "landscape", component: Landscape, meta: { isAdmin: true ,requiresAuth: true, title: "页面景观管理" } },
      { path: "userContactHistory", component: UserContactHistory, meta: { isAdmin: true ,requiresAuth: true, title: "用户联系历史" } }
    ],
  },

  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  // mode: "history",
  mode: "hash",

  routes,
  scrollBehavior(to, from, savedPosition) {
    // return { x: 0, y: 0 };
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
// ========== 路由守卫（后台鉴权） ==========
// 修改 router/index.js 中的路由守卫
router.beforeEach(async (to, from, next) => {
  // 用户端页面标题
  const siteName = "中科淞塔（苏州）科技有限公司";
  const pageTitle = to.meta.title ? `${to.meta.title} - ${siteName}` : siteName;
  document.title = pageTitle;

  // 管理员后台标题（保持原有逻辑）
  if (to.path.startsWith("/admin")) {
    document.title = to.meta.title ? `${to.meta.title} - 中科淞塔管理后台` : "中科淞塔管理后台";
  }

  // 以下保持你现有鉴权逻辑
  if (to.path === "/admin/login") {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUserInfo");
    return next();
  }

  if (to.meta.isPublic) return next();

  if (to.meta.requiresAuth) {
    const token = localStorage.getItem("adminToken");
    if (!token) {
      try { next(false); await router.push("/admin/login"); } catch(err){ console.warn(err); }
      return;
    }
    next();
  } else {
    next();
  }
});

router.onError((err) => {
  if (err.name === "ChunkLoadError") {
    router.app.$notify.error("网络资源加载错误");
  }
});
